module.exports = __webpack_public_path__ + "static/media/Page32.6fc1c850.png";